class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.overlay = document.querySelector('#headerNavOverlay')

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle (e) {
    e.preventDefault();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.classList.add('opening');
      this.overlay.classList.add('is-active');

      setTimeout(() => {
        this.overlay.classList.add('is-visible');
      })

      setTimeout(() => {
        this.mainDetailsToggle.classList.remove('opening');
        this.mainDetailsToggle.classList.add('opened');
      }, 400)
    } else {
      this.mainDetailsToggle.classList.add('closing');
      this.overlay.classList.remove('is-visible');

      setTimeout(() => {
        this.overlay.classList.remove('is-active');
      })

      setTimeout(() => {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.classList.remove('closing');
        this.mainDetailsToggle.classList.remove('opened');
      }, 400)
    }
  }

  close () {
    this.mainDetailsToggle.classList.remove('closing');
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.classList.remove('opened');

    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    this.overlay.classList.remove('is-visible');
    this.overlay.classList.remove('is-active');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
